/*
 Copyright (C) Sesam.io - All Rights Reserved.
 Unauthorized copying of this file, via any medium is strictly prohibited.
 */
import React from 'react';

import { DatahubSettings } from '../../../containers/DatahubSettings.container';
import { PermissionsEditor } from 'Common/PermissionsEditor';

function SettingsDatahubPermissions() {
  return (
    <DatahubSettings>
      <main className="scrollArea">
        <PermissionsEditor permission="node" />
      </main>
    </DatahubSettings>
  );
}

export default SettingsDatahubPermissions;
